import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="container section">
      <h1>Page not found</h1>
      <p>
        <Link to="/">Back to Northwind</Link>
      </p>
    </div>
  );
}
